import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
/**
 * @class LinkedAccount
 * @classdesc Class definition for record type
 * @param {OBJECT} record - The record from the states or countries objects
 * @example const LinkedAccount = LinkedAccount.initByName("Germany");
 * 
 * @property {STRING} _id - The name of the LinkedAccount
 * @property {STRING} _fi_name - The abbreviation of the LinkedAccount
 *  * @property {STRING} _type - Selected property from copying it over from the LinkedAccount select
 * @property {STRING} _status - Selected property from copying it over from the LinkedAccount select
 * @property {STRING} _last_four_digit_number - If the LinkedAccount is a state
 * @property {STRING} _current_balance - The flag icon associated to the LinkedAccount
 *  @property {bcmsCurrency} _available_credit - The flag icon associated to the LinkedAccount
 *  @property {STRING} _routing_number - The flag icon associated to the LinkedAccount
 */ 
export default class LinkedAccount extends BCMSRecord {
    _id;
    _fi_name;
    _status;
    _type;
    _last_four_digit_number;
    _available_credit;
    _routing_number;

    constructor(record) {
        super(record)
    }
}
   
    LinkedAccount.define({
    "recordType": "linkedAccounts",
    "recordIDProp": "id",
    "className" : "LinkedAccount",
    "recordProperties": [
       
     
     /** 
      * @name id
      * @instance
      * @property get {STRING} - gets the id of the linkedAccount
      * @property set {STRING} - sets the id of the linkedAccount
      * @memberof LinkedAccount 
      */
  
      BCMSRecordProperty.mapToString("id", "_id"),
     
      /** 
       * @name fi_name
       * @instance
       * @property get {STRING} - gets the _fi_name of the linkedAccount
       * @property set {STRING} - sets the _fi_name of the linkedAccount
       * @memberof LinkedAccount 
       */
  
       BCMSRecordProperty.mapToString("fi_name", "_fi_name"),
    
     /** 
      * @name type
      * @instance
      * @property get {STRING} - gets the type of the linkedAccount
      * @property set {STRING} - sets the type of the linkedAccount
      * @memberof LinkedAccount 
      */
  
        BCMSRecordProperty.mapToString("type", "_type"),
     /** 
      * @name status
      * @instance
      * @property get {STRING} - gets the status of the linkedAccount
      * @property set {STRING} - sets the status of the linkedAccount
      * @memberof LinkedAccount 
      */
  
      BCMSRecordProperty.mapToString("status", "_status"),
     
     
      
     /** 
      * @name last_four_digit_number
      * @instance
      * @property get {STRING} - gets the last_four_digit_number of the linkedAccount
      * @property set {STRING} - sets the last_four_digit_number of the linkedAccount
      * @memberof LinkedAccount 
      */
  
      BCMSRecordProperty.mapToString("last_four_digit_number", "_last_four_digit_number"),
     
      /** 
       * @name available_credit
       * @instance
       * @property get {bcmsCurrency} - gets the _available_credit of the linkedAccount
       * @property set {bcmsCurrency} - sets the _available_credit of the linkedAccount
       * @memberof LinkedAccount 
       */
  
       BCMSRecordProperty.mapToCurrency("available_credit", "_available_credit"),
        /** 
       * @name routing_number
       * @instance
       * @property get {STRING} - gets the _routing_number of the linkedAccount
       * @property set {STRING} - sets the _routing_number of the linkedAccount
       * @memberof LinkedAccount 
       */
  
    BCMSRecordProperty.mapToString("routing_number", "_routing_number")
    ]
})